import { css } from 'styled-components';
import { LoaderContainer } from 'modules/v2/feedback/Loader/styled';
import { pxToRem } from '../../foundation/spacing';
import { themeGet, themeGetColor } from '../../foundation/theme';
import { PrimaryLabel, SecondaryLabel } from './styled';
const styles = {
    glass: {
        solid: {
            background: themeGetColor('gray.0', 0.05),
            hover: {
                background: themeGetColor('background.50', 0.2),
            },
            active: {
                background: themeGetColor('background.50', 0.2),
            },
            focus: {
                shadowColor: themeGet('colors.focus.primary'),
            },
            color: themeGet('colors.text.light'),
            secondaryColor: themeGetColor('text.light', 0.75),
            iconColor: themeGetColor('text.light'),
        },
        outline: {
            background: themeGetColor('gray.0', 0.05),
            borderColor: themeGetColor('gray.0', 0.05),
            hover: {
                background: themeGetColor('background.50', 0.2),
            },
            active: {
                background: themeGetColor('background.50', 0.2),
            },
            focus: {
                shadowColor: themeGet('colors.focus.primary'),
            },
            color: themeGet('colors.text.light'),
            secondaryColor: themeGetColor('text.light', 0.75),
            iconColor: themeGet('colors.primary.600'),
        },
    },
    primary: {
        solid: {
            background: themeGet('colors.secondary.50'),
            hover: {
                background: themeGet('colors.secondary.100'),
            },
            active: {
                background: themeGet('colors.secondary.200'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.secondary'),
            },
            color: themeGet('colors.secondary.500'),
            iconColor: themeGet('colors.secondary.500'),
        },
        outline: {
            background: themeGet('colors.background.50'),
            borderColor: themeGet('colors.secondary.500'),
            hover: {
                background: themeGet('colors.secondary.50'),
                borderColor: themeGet('colors.secondary.500'),
            },
            active: {
                background: themeGet('colors.secondary.100'),
                borderColor: themeGet('colors.secondary.500'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.secondary'),
            },
            color: themeGet('colors.secondary.500'),
            iconColor: themeGet('colors.secondary.500'),
        },
    },
    secondary: {
        solid: {
            background: themeGet('colors.background.100'),
            hover: {
                background: themeGet('colors.primary.100'),
            },
            active: {
                background: themeGet('colors.primary.200'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.secondary'),
            },
            color: themeGet('colors.text.200'),
            iconColor: themeGet('colors.primary.600'),
        },
        outline: {
            background: themeGet('colors.background.50'),
            borderColor: themeGet('colors.border.100'),
            hover: {
                background: themeGet('colors.primary.50'),
                borderColor: themeGet('colors.border.100'),
            },
            active: {
                background: themeGet('colors.primary.100'),
                borderColor: themeGet('colors.border.100'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.secondary'),
            },
            color: themeGet('colors.text.200'),
            iconColor: themeGet('colors.primary.600'),
        },
    },
    success: {
        solid: {
            background: themeGet('colors.green.50'),
            hover: {
                background: themeGet('colors.green.100'),
            },
            active: {
                background: themeGet('colors.green.200'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.success'),
            },
            color: themeGet('colors.text.success'),
            iconColor: themeGet('colors.green.500'),
        },
        outline: {
            background: themeGet('colors.background.50'),
            borderColor: themeGet('colors.green.500'),
            hover: {
                background: themeGet('colors.green.50'),
                borderColor: themeGet('colors.green.500'),
            },
            active: {
                background: themeGet('colors.green.100'),
                borderColor: themeGet('colors.green.500'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.success'),
            },
            color: themeGet('colors.text.success'),
            iconColor: themeGet('colors.green.500'),
        },
    },
    danger: {
        solid: {
            background: themeGet('colors.red.50'),
            hover: {
                background: themeGet('colors.red.100'),
            },
            active: {
                background: themeGet('colors.red.200'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.danger'),
            },
            color: themeGet('colors.text.danger'),
            iconColor: themeGet('colors.red.500'),
        },
        outline: {
            background: themeGet('colors.background.50'),
            borderColor: themeGet('colors.red.500'),
            hover: {
                background: themeGet('colors.red.50'),
                borderColor: themeGet('colors.red.500'),
            },
            active: {
                background: themeGet('colors.red.100'),
                borderColor: themeGet('colors.red.500'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.danger'),
            },
            color: themeGet('colors.text.danger'),
            iconColor: themeGet('colors.red.500'),
        },
    },
    warning: {
        solid: {
            background: themeGet('colors.yellow.50'),
            hover: {
                background: themeGet('colors.yellow.100'),
            },
            active: {
                background: themeGet('colors.yellow.200'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.warning'),
            },
            color: themeGet('colors.yellow.900'),
            iconColor: themeGet('colors.yellow.900'),
        },
        outline: {
            background: themeGet('colors.background.50'),
            borderColor: themeGet('colors.yellow.500'),
            hover: {
                background: themeGet('colors.yellow.50'),
                borderColor: themeGet('colors.yellow.500'),
            },
            active: {
                background: themeGet('colors.yellow.100'),
                borderColor: themeGet('colors.yellow.500'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.warning'),
            },
            color: themeGet('colors.yellow.900'),
            iconColor: themeGet('colors.yellow.900'),
        },
    },
    info: {
        solid: {
            background: themeGet('colors.blue.50'),
            hover: {
                background: themeGet('colors.blue.100'),
            },
            active: {
                background: themeGet('colors.blue.200'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.info'),
            },
            color: themeGet('colors.blue.500'),
            iconColor: themeGet('colors.blue.500'),
        },
        outline: {
            background: themeGet('colors.background.50'),
            borderColor: themeGet('colors.blue.500'),
            hover: {
                background: themeGet('colors.blue.50'),
                borderColor: themeGet('colors.blue.500'),
            },
            active: {
                background: themeGet('colors.blue.100'),
                borderColor: themeGet('colors.blue.500'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.info'),
            },
            color: themeGet('colors.blue.500'),
            iconColor: themeGet('colors.blue.500'),
        },
    },
    assistant: {
        solid: {
            background: themeGet('colors.assistant.50'),
            hover: {
                background: themeGet('colors.assistant.100'),
            },
            active: {
                background: themeGet('colors.assistant.200'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.assistant'),
            },
            color: themeGet('colors.assistant.500'),
            iconColor: themeGet('colors.assistant.500'),
        },
        outline: {
            background: themeGet('colors.background.50'),
            borderColor: themeGet('colors.assistant.500'),
            hover: {
                background: themeGet('colors.assistant.50'),
                borderColor: themeGet('colors.assistant.500'),
            },
            active: {
                background: themeGet('colors.assistant.100'),
                borderColor: themeGet('colors.assistant.500'),
            },
            focus: {
                shadowColor: themeGet('colors.focus.assistant'),
            },
            color: themeGet('colors.assistant.500'),
            iconColor: themeGet('colors.assistant.500'),
        },
    },
};
function getOutlineCSS(appearance) {
    return css `
    background: ${appearance.background};
    border-color: ${appearance.borderColor};

    &:is(button) {
      &:hover {
        background-color: ${appearance.hover.background};
        border-color: ${appearance.hover.borderColor};
      }

      &:active {
        background-color: ${appearance.active.background};
        border-color: ${appearance.active.borderColor};
      }

      &:focus-visible {
        box-shadow: 0 0 0 ${pxToRem(4)} ${appearance.focus.shadowColor};
      }
    }

    ${PrimaryLabel} {
      color: ${appearance.color};
    }

    ${appearance.secondaryColor &&
        css `
      ${SecondaryLabel} {
        color: ${appearance.secondaryColor};
      }
    `};

    [data-icon='falcon'] {
      color: ${appearance.iconColor};
    }

    ${LoaderContainer} {
      color: ${appearance.iconColor};
    }
  `;
}
function getSolidCSS(appearance) {
    return css `
    background: ${appearance.background};
    border-color: transparent;

    &:is(button) {
      &:hover {
        background-color: ${appearance.hover.background};
      }

      &:active {
        background-color: ${appearance.active.background};
      }

      &:focus-visible {
        box-shadow: 0 0 0 ${pxToRem(4)} ${appearance.focus.shadowColor};
      }
    }

    ${PrimaryLabel} {
      color: ${appearance.color};
    }

    ${appearance.secondaryColor &&
        css `
      ${SecondaryLabel} {
        color: ${appearance.secondaryColor};
      }
    `};

    [data-icon='falcon'] {
      color: ${appearance.iconColor};
    }

    ${LoaderContainer} {
      color: ${appearance.iconColor};
    }
  `;
}
export const getChipAppearance = (appearance, variant) => {
    const defaultStyle = styles.primary.solid;
    const selectedAppearance = styles[appearance] || {};
    if (variant === 'outline') {
        return getOutlineCSS(selectedAppearance[variant]);
    }
    return getSolidCSS(selectedAppearance[variant] || defaultStyle);
};
